import { createContext, useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import { BASE_API } from '../config';
// utils
import axios from '../utils/axios';
import { isValidToken, setSession } from '../utils/jwt';


// ----------------------------------------------------------------------

const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null,
};

const handlers = {
  INITIALIZE: (state, action) => {
    const { isAuthenticated, user } = action.payload;
    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      user,
    };
  },
  LOGIN: (state, action) => {
    const { user } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
    };
  },
  LOGOUT: (state) => ({
    ...state,
    isAuthenticated: false,
    user: null,
  }),
  REGISTER: (state, action) => {
    const { user } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
    };
  },
};

const reducer = (state, action) => (handlers[action.type] ? handlers[action.type](state, action) : state);

const AuthContext = createContext({
  ...initialState,
  method: 'jwt',
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  register: () => Promise.resolve(),
});

// ----------------------------------------------------------------------

AuthProvider.propTypes = {
  children: PropTypes.node,
};

function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const initialize = async () => {
      try {
        const accessToken = window.localStorage.getItem('accessToken');
        const id = window.localStorage.getItem('userId');
        const headers = { 
          'content-type': 'application/json', 
          'Authorization': `Bearer ${accessToken}`
        }
        if (accessToken && isValidToken(accessToken)) {
          setSession(accessToken);
          

          const response = await axios.get(`${BASE_API}/api/users/${id}/profile`,{headers});
          const datt = response.data;
          const user = JSON.stringify(datt.user.id)

          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: true,
              user,
            },
          });
        } else {
          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: false,
              user: null,
            },
          });
        }
      } catch (err) {
        console.error(err);
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null,
          },
        });
      }
    };

    initialize();
  }, []);

  const login = async (email, password) => {
    const response = await axios.post(`${BASE_API}/api/auth/login`, {
      email,
      password,
    });
    
    const { accessToken } = response.data;
    console.log (response.data)
    const {id} = response.data.user
    const headers = { 
      'content-type': 'application/json', 
      'Authorization': `Bearer ${accessToken}`
    }
    console.log(headers)
    
    const responseUser =await axios.get(`${BASE_API}/api/users/${id}/profile`,{headers});
          const datt = responseUser.data;
          console.log ("datt",datt )
          const user = JSON.stringify(datt.user.id)
          window.localStorage.setItem('token', accessToken);
          window.localStorage.setItem('userId', id);

    
    setSession(accessToken);
    dispatch({
      type: 'LOGIN',
      payload: {
        user,
      },
    });
  };

  const register = async (email, password, firstName, lastName, company) => {
    const response = await axios.post(`${BASE_API}/api/auth/register`, {
      email,
      password,
      name:firstName,
      username:lastName,
      admin :company,
    });
    const { accessToken, user } = response.data;

    window.localStorage.setItem('accessToken', accessToken);
    dispatch({
      type: 'REGISTER',
      payload: {
        user,
      },
    });
  };

  const logout = async () => {
    setSession(null);
    dispatch({ type: 'LOGOUT' });
  };

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: 'jwt',
        login,
        logout,
        register,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
